import { render } from "./MfaCard.vue?vue&type=template&id=60de06e4"
import script from "./MfaCard.vue?vue&type=script&lang=js"
export * from "./MfaCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__